import Button from "../Button/Button";
import type { IconComponentType } from "../Icon/Icon";
import styles from "./TileButton.module.scss";

function TileButton({
  title,
  subtitle,
  IconComponent,
  onClick,
}: {
  title: string;
  subtitle: string;
  IconComponent: IconComponentType;
  onClick?: () => void;
}) {
  return (
    <Button onClick={onClick} variant="unstyled">
      <div className={styles.tile}>
        <IconComponent className={styles.tileIcon} size="medium" />
        <div className={styles.tileText}>
          <h3 className={styles.tileTitle}>{title}</h3>
          <p className={styles.tileSubtitle}>{subtitle}</p>
        </div>
      </div>
    </Button>
  );
}

export default TileButton;
